import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create a separate instance for API calls (with /api prefix)
const apiWithPrefix = axios.create({
  baseURL: API_BASE_URL + '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function stripJsonContentTypeForFormData(config) {
  if (typeof FormData === 'undefined' || !(config.data instanceof FormData)) {
    return;
  }
  const h = config.headers;
  if (!h) return;
  if (typeof h.delete === 'function') {
    h.delete('Content-Type');
    h.delete('content-type');
  } else {
    delete h['Content-Type'];
    delete h['content-type'];
  }
}

// Function to add interceptors to an axios instance
const addInterceptors = (axiosInstance) => {
  // Request interceptor to add auth token
  axiosInstance.interceptors.request.use(
    (config) => {
      stripJsonContentTypeForFormData(config);
      const userInfo = localStorage.getItem('user-info');
      if (userInfo) {
        const { accessToken, token } = JSON.parse(userInfo);
        const authToken = accessToken || token; // Support both field names
        if (authToken) {
          config.headers.Authorization = `Bearer ${authToken}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor for error handling
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { response } = error;
      
      if (response?.status === 401) {
        // Try to refresh token first
        const userInfo = localStorage.getItem('user-info');
        if (userInfo) {
          try {
            const { refreshToken } = JSON.parse(userInfo);
            if (refreshToken) {
              const refreshResponse = await api.post('/auth/token', { refreshToken });
              const newAccessToken = refreshResponse.data.accessToken;
              
              // Update stored token
              const updatedUserInfo = { ...JSON.parse(userInfo), accessToken: newAccessToken, token: newAccessToken };
              localStorage.setItem('user-info', JSON.stringify(updatedUserInfo));
              
              // Retry original request
              error.config.headers.Authorization = `Bearer ${newAccessToken}`;
              return axiosInstance.request(error.config);
            }
          } catch (refreshError) {
            console.error('Token refresh failed:', refreshError);
          }
        }
        
        // If refresh fails, redirect to login
        localStorage.removeItem('user-info');
        window.location.href = '/login';
      }
      
      return Promise.reject(error);
    }
  );
};

// Add interceptors to both instances
addInterceptors(api);
addInterceptors(apiWithPrefix);

// Export the auth API (for /auth endpoints) as default
export default api;

// Export the API with prefix (for /api endpoints)
export { apiWithPrefix };